import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess129301Status: 'idle',
    startProcess129301Error: undefined as any,
    loadUserParamsProcess129301Status: 'idle',
    loadUserParamsProcess129301Error: undefined as any,

    process129301List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess129301 = createAsyncThunk('process129301Slice/startProcess129301', async ({ process129301 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess129301/`,
        prepareData(process129301),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess129301Status } = getState().process129301Slice
        return startProcess129301Status !== 'pending'
    }
})

export const loadUserParamsProcess129301 = createAsyncThunk('process129301Slice/loadUserParamsProcess129301', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess129301/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess129301Status } = getState().process129301Slice
        return loadUserParamsProcess129301Status !== 'pending'
    }
})

const Process129301Slice = createSlice({
    name: 'process129301Slice',
    initialState,
    reducers: {
        resetstartProcess129301: (state) => {
            state.job = undefined
            state.startProcess129301Error = undefined
        },
        resetstartProcess129301Error: (state) => {
            state.startProcess129301Error = undefined
        },
        resetloadUserParamsProcess129301: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess129301Error = undefined
        },
        resetloadUserParamsProcess129301Error: (state) => {
            state.loadUserParamsProcess129301Error = undefined
        },
        removeFromProcess129301ListById: (state, action) => {
            state.process129301List = state.process129301List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess129301ListByIds: (state, action) => {
            state.process129301List = state.process129301List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process129301List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess129301Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process129301List = []
            state.startProcess129301Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess129301.pending, (state) => {
            state.startProcess129301Status = 'pending'
            state.startProcess129301Error = undefined
        })
        builder.addCase(startProcess129301.fulfilled, (state, action) => {
            state.startProcess129301Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess129301.rejected, (state, action) => {
            state.startProcess129301Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess129301Error = action.error.message
            } else {
                state.startProcess129301Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess129301.pending, (state) => {
            state.loadUserParamsProcess129301Status = 'pending'
            state.loadUserParamsProcess129301Error = undefined
        })
        builder.addCase(loadUserParamsProcess129301.fulfilled, (state, action) => {
            state.loadUserParamsProcess129301Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess129301.rejected, (state, action) => {
            state.loadUserParamsProcess129301Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess129301Error = action.error.message
            } else {
                state.loadUserParamsProcess129301Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess129301,
    resetstartProcess129301Error,
    resetloadUserParamsProcess129301,
    resetloadUserParamsProcess129301Error,
    removeFromProcess129301ListById,
    removeFromProcess129301ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process129301Slice.actions
export default Process129301Slice.reducer
